(function () {
  if (window.customElements.get('se-option-cards')) return;
  function findInput(id) {
    return document.querySelector('variant-picker input[data-option-value-id="' + id + '"]');
  }
  class SeOptionCards extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._onClick = function (e) {
        var b = e.target.closest('[data-ovid]');
        if (!b) return;
        var inp = findInput(b.dataset.ovid);
        if (inp && !inp.checked) inp.click();
        self.querySelectorAll('[data-ovid]').forEach(function (x) {
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
      };
      this._sync = function () {
        self.querySelectorAll('[data-ovid]').forEach(function (x) {
          var i = findInput(x.dataset.ovid);
          if (i) x.setAttribute('aria-pressed', i.checked ? 'true' : 'false');
        });
      };
      this.addEventListener('click', this._onClick);
      document.addEventListener('change', this._sync);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      document.removeEventListener('change', this._sync);
    }
  }
  window.customElements.define('se-option-cards', SeOptionCards);
})();
